import { StyledProps, React, withStyles } from '@api';
import Snackbar from '@material-ui/core/Snackbar'
import {site, ui} from '@stores'
import { Button, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close'

const styles = theme => ({
  close: {
    width: `2.4rem`,
    height: `2.4rem`,
    position: "absolute",
    top: "0",
    right: "5px",
},
  message: {
    fontSize: '12px',
    overflowWrap: "break-word",
    width: "500px%"
  },
  snackbar: {
    zIndex: 9999999
  },
  refresh:{
    marginRight: "23px"
  }
})

interface MyProps extends StyledProps {
  vertical?: any
  horizontal?: any
  open?: boolean
  handleClose?: (e, reason?: any) => void
  errorMessage?: string
}

@(withStyles as any)(styles)
export class ErrorComponent extends React.Component<MyProps> {
  handleRefresh = () => {
    site?.forceReloadPage()
  }

  render() {
    const { props: { errorMessage, vertical, horizontal, open, classes, handleClose }, handleRefresh } = this

    return <Snackbar
      anchorOrigin={{ vertical: vertical, horizontal: horizontal }}
      open={open}
      onClose={handleClose}
      autoHideDuration={ui.settings.AUTOHIDE_SNACKBAR_DURATION}
      ContentProps={{
        'aria-describedby': 'message-id'
      }}
      classes={{ root: this.props.classes.snackbar }}
      message={<div id='message-id' className={classes.message}>{errorMessage}</div>}
      action={[
        <Button key="undo"
                color="secondary" size="small" className={classes.refresh} onClick={handleRefresh}>
          REFRESH
       </Button>, <IconButton
          key='close'
          aria-label='Close'
          color='inherit'
          className={classes.close}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      ]}
    />
  }
}



// WEBPACK FOOTER //
// ./src/modules/errors/components/Error.tsx